import axios from 'axios'
import { CALL_API } from 'tr-components/redux/CallApiMiddlewareActionCreator'

export const FETCH_FIELD_LOCATIONS = 'fields/FETCH_FIELD_LOCATIONS'
export const FETCH_FIELD_LOCATIONS_SUCCESS = 'fields/FETCH_FIELD_LOCATIONS_SUCCESS'
export const FETCH_FIELD_LOCATIONS_FAIL = 'fields/FETCH_FIELD_LOCATIONS_FAIL'
export const FETCH_FIELD_TYPES = 'fields/FETCH_FIELD_TYPES'
export const FETCH_FIELD_TYPES_SUCCESS = 'fields/FETCH_FIELD_TYPES_SUCCESS'
export const FETCH_FIELD_TYPES_FAIL = 'fields/FETCH_FIELD_TYPES_FAIL'

export const initialState = {
  fetchingLocations: false,
  fetchingTypes: false,
  locationsErr: null,
  typesErr: null,
  types: [],
  locations: []
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_FIELD_LOCATIONS:
      return {
        ...state,
        fetchingLocations: true,
        locationsErr: null
      }
    case FETCH_FIELD_LOCATIONS_SUCCESS:
      return {
        ...state,
        fetchingLocations: false,
        locations: action.payload.events
      }
    case FETCH_FIELD_LOCATIONS_FAIL:
      return {
        ...state,
        fetchingLocations: false,
        locationsErr: action.payload
      }

    case FETCH_FIELD_TYPES:
      return {
        ...state,
        fetchingTypes: true,
        typesErr: null
      }
    case FETCH_FIELD_TYPES_SUCCESS:
      return {
        ...state,
        fetchingTypes: false,
        types: action.payload.types
      }
    case FETCH_FIELD_TYPES_FAIL:
      return {
        ...state,
        fetchingTypes: false,
        typesErr: action.payload
      }
    default:
      return state
  }
}

export default reducer

export const fetchLocations = () => {
  return {
    type: CALL_API,
    types: [FETCH_FIELD_LOCATIONS, FETCH_FIELD_LOCATIONS_SUCCESS, FETCH_FIELD_LOCATIONS_FAIL],
    callAPI: () => axios.get('/fields/fieldEvents')
  }
}

export const fetchTypes = () => {
  return {
    type: CALL_API,
    types: [FETCH_FIELD_TYPES, FETCH_FIELD_TYPES_SUCCESS, FETCH_FIELD_TYPES_FAIL],
    callAPI: () => axios.get('/fields/fieldTypes')
  }
}



// WEBPACK FOOTER //
// ./src/modules/CustomFields/redux/fieldTypesAndLocations.js